module.exports = __webpack_public_path__ + "img/druid.ae3db8b4.jpg";